import { Page } from '@/core/architecture'

import { ConsoleEventCollectionReceiveTimeEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleEventCollectionReceiveTimeEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleEventCollectionReceiveTimeEdit: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ConsoleEventCollectionReceiveTimeEditTemplate state={state} {...actions} />
  )
}
